import axios from 'axios';

// 创建独立的 axios 实例用于代理接口（/group 和 /h5）
export const proxyAction = axios.create({
    // timeout: 10000, // 超时时间
});

// 代理接口响应拦截器
proxyAction.interceptors.response.use(
    // 成功响应处理
    function(response) {
        const responseData = response.data;
        const contentType = response.headers['content-type'] || response.headers['Content-Type'] || '';
        
        // 检查是否是 HTML 响应
        if (contentType.includes('text/html') || (typeof responseData === 'string' && responseData.trim().startsWith('<!DOCTYPE'))) {
            return Promise.reject(new Error('接口返回了 HTML 页面，请检查代理配置'));
        }
        
        // 如果响应数据是字符串，尝试解析为 JSON
        let data = responseData;
        if (typeof responseData === 'string') {
            // 检查是否是 HTML
            if (responseData.trim().startsWith('<!DOCTYPE') || responseData.trim().startsWith('<html')) {
                return Promise.reject(new Error('接口返回了 HTML 页面，请检查代理配置'));
            }
            try {
                data = JSON.parse(responseData);
            } catch (e) {
                // 解析失败，直接返回原始数据
                return responseData;
            }
        }
        
        // 检查是否有 code 字段（标准格式：{code: 10000, data: {...}} 或 {code: 0, data: {...}}）
        if (data && typeof data === 'object' && 'code' in data) {
            const { code, data: responseDataField, msg, message, success } = data;
            
            // 判断是否成功（code 为 10000 或 0，或者 success 为 true）
            if (code === 10000 || code === 0 || success === true) {
                // 成功，返回 data 字段，如果没有 data 字段则返回整个对象
                return responseDataField !== undefined ? responseDataField : data;
            } else if (code !== undefined && code !== null) {
                // code 存在但不是成功值，返回错误
                return Promise.reject(new Error(msg || message || `请求失败，错误码：${code}`));
            }
        }
        
        // 如果没有 code 字段，或者 code 为 undefined/null，说明响应格式可能是直接返回数据（如 {list: {...}}）
        // 直接返回响应数据
        return data;
    },
    // 失败响应处理
    function(error) {
        const msg = error.response?.data?.msg || error.response?.data?.message || error.message || '请求失败';
        return Promise.reject(new Error(msg));
    }
);
